/*
Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.

Licensed under the Apache License, Version 2.0 (the "License").
You may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
import React from 'react';
import { useTranslation } from 'react-i18next';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import { useDispatch } from 'react-redux';
import { auth } from '@ink-ai/portal/reducers/auth';

export const Logout = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  return (
    <ListItemButton sx={{ padding: '8px 24px' }} onClick={() => dispatch(auth.actions.signOut())}>
      <ListItemIcon
        sx={(theme) => ({
          color: theme.palette.error.main,
        })}
      >
        <PowerSettingsNewIcon />
      </ListItemIcon>
      <ListItemText primary={t('userConfig.logout')} />
    </ListItemButton>
  );
};
